import React from "react";
import "./ArticlePreviewMosaicItem.css";
import ReactHtmlParser from "react-html-parser";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { ACDTYPE_VIDEO } from "../../model/ACDTypes";
import {
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import { combineTextLineIDs } from "../../model/privateACDType";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class ArticlePreviewMosaicItem extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);

    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
  }

  onHover(hovering) {
    const {
      item,
      setPreviewingTextLineIDs,
      setPreviewingImageIDs
    } = this.props;

    if (hovering) {
      const reducer = (accumulator, currentValue) =>
        combineTextLineIDs(accumulator, currentValue.textLineIDs);
      const allTextLineIDs = item.imageItemArr.reduce(
        reducer,
        item.textLineIDs
      );
      const allImageIDs = item.imageItemArr.map(item => item.image.id);

      setPreviewingTextLineIDs({ textLineIDs: allTextLineIDs });
      setPreviewingImageIDs({ imageIDs: allImageIDs });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
      setPreviewingImageIDs({ imageIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "highlight" });
    }
  }

  render() {
    const { item, mode } = this.props;
    const { imageItemArr } = item;

    if (imageItemArr == null || imageItemArr.length <= 0) {
      return null;
    }

    return (
      <div style={{ position: "relative", paddingTop: "15pt" }}>
        <div
          className="mosaic_main_container"
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          <Container>
            <Row>
              {imageItemArr.map((anImageItem, idx) => {
                let imgUri;
                if (anImageItem.dataType === ACDTYPE_VIDEO) {
                  imgUri = `${process.env.REACT_APP_API_ROOT}artworks/${
                    anImageItem.media.thumbnail.id
                  }/static`;
                } else {
                  imgUri = `${process.env.REACT_APP_API_ROOT}artworks/${
                    anImageItem.image.id
                  }/static`;
                }

                return (
                  <Col
                    key={anImageItem.id}
                    xs="4"
                    sm="4"
                    md="4"
                    lg="4"
                    xl="4"
                    style={{ padding: 0, textAlign: "center" }}
                  >
                    <div
                      className="article_mosaic_image_div"
                      style={{ height: "115pt" }}
                    >
                      <img
                        className="article_mosaic_image"
                        alt={anImageItem.text}
                        src={imgUri}
                      />
                      {anImageItem.text != null && anImageItem.text !== "" && (
                        <div className="article_mosaic_image_overlay">
                          <span className="article_mosaic_image_single_caption">
                            {ReactHtmlParser(
                              anImageItem.text.replace(/\n/g, "<br>")
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>
          {item.text != null && item.text !== "" && (
            <span className="article_preview_mosaic_caption">
              {ReactHtmlParser(item.text.replace(/\n/g, "<br>"))}
            </span>
          )}
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: "20pt", right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  return {
    mode: previewHidingItemIDs[ownProps.item.id]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewMosaicItem);
